// ================================================================================
// Custom events
//
// To help make it easier to add custom functionality, the theme emits custom
// events (along with their associated data) related to key theme features.
//
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// ================================================================================

function n$2(n,t){return void 0===t&&(t=document),t.querySelector(n)}function t$2(n,t){return void 0===t&&(t=document),[].slice.call(t.querySelectorAll(n))}function c$1(n,t){return Array.isArray(n)?n.forEach(t):t(n)}function r$2(n){return function(t,r,e){return c$1(t,function(t){return t[n+"EventListener"](r,e)})}}function e$2(n,t,c){return r$2("add")(n,t,c),function(){return r$2("remove")(n,t,c)}}function o$2(n){return function(t){var r=arguments;return c$1(t,function(t){var c;return (c=t.classList)[n].apply(c,[].slice.call(r,1))})}}function u$1(n){o$2("add").apply(void 0,[n].concat([].slice.call(arguments,1)));}function i$1(n){o$2("remove").apply(void 0,[n].concat([].slice.call(arguments,1)));}function l(n){o$2("toggle").apply(void 0,[n].concat([].slice.call(arguments,1)));}function a$1(n,t){return n.classList.contains(t)}

/* eslint-disable no-console */

// ================================================================================
// "Item added to the cart"
//
// - Fires whenever an item has been added to the cart
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The associated product object
// ================================================================================
// document.addEventListener("cart:item-added", function (evt) {
//   console.log("Item added to the cart");
//   console.log(evt.detail.product);
// });

// ================================================================================
// "Cart updated"
//
// - Fires whenever the cart is updated
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
// document.addEventListener("cart:updated", function (evt) {
//   console.log("Cart updated");
//   console.log(evt.detail.cart);
// });

// ================================================================================
// "Cart error"
//
// - Fires whenever there is an error when adding an item to the cart
//   - Typically due to a product not having sufficient stock
// - "detail" object data:
//   - The error message
// ================================================================================
// document.addEventListener("cart:error", function (evt) {
//   console.log("Cart error");
//   console.log(evt.detail.errorMessage);
// });

// ================================================================================
// "Quick cart opened"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// - "detail" object data:
//   - The cart object
// ================================================================================
// document.addEventListener("quick-cart:open", function (evt) {
//   console.log("Quick cart opened");
//   console.log(evt.detail.cart);
// });

// ================================================================================
// "Quick cart closed"
//
// - Fires whenever the quick cart is opened
// - Exposed when the ajax cart is enabled
// ================================================================================
// document.addEventListener("quick-cart:close", function () {
//   console.log("Quick cart closed");
// });

// ================================================================================
// "Product variant changed"
//
// - Fires whenever a variant product is selected
// - Exposed when a 'Variant selectors' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
// ================================================================================
document.addEventListener("product:variant-change", function (evt) {
  let variantMetafields = document.querySelector('script[data-variant-metafields-json]').textContent;
  let descriptionEl = document.querySelector('[data-product-block-description]');
  variantMetafields = JSON.parse(variantMetafields);

  const variant = variantMetafields[evt.detail.variant.id];
  
  if (variant.variant_description && variant.variant_description.length > 0) {
    descriptionEl.innerHTML = variant.variant_description;
  }

  if (variant.bom_contents 
      && variant.bom_contents.length > 0 
      && variant.bom_contents !== "No contents found."
    ) {
    let bomEl = document.querySelector('[data-product-block-bom]');
    let boms = JSON.parse(variant.bom_contents)

    const newUl = document.createElement('ul');
      newUl.setAttribute('data-product-block-bom', '');


    newUl.innerHTML = "";
    boms.forEach(bom => {
      let li = document.createElement('li');
      li.innerHTML = bom;
      newUl.appendChild(li);
    });

    bomEl.replaceWith(newUl);
  }
});

// ================================================================================
// "Product quantity updated"
//
// - Fires whenever a product quanatiy is updated
// - Exposed when a 'Quantity selector' block has been added to a product template
//   or featured product section
// - "detail" object data:
//   - The variant object
//   - The quantity
// ================================================================================
// document.addEventListener("product:quantity-update", function (evt) {
//   console.log("Product quantity updated");
//   console.log(evt.detail.quantity, evt.detail.variant);
// });

// ================================================================================
// "Quick view loaded"
//
// - Fires whenever a quick view modal is opened
// - Exposed when the 'Enable quick view' setting is enabled and a quick view
//   modal is opened
// ================================================================================
// document.addEventListener("quick-view:loaded", function () {
//   console.log("Quick view loaded");
// });

// ================================================================================
// "Address modal opened"
//
// - Fires whenever an add address modal is opened
// - Exposed when the 'Enable address modal' setting is enabled and an address
//   modal is opened
// ================================================================================
document.addEventListener("address:modal-opened", function (evt) {
  console.log("Address modal opened", evt);
  const modal = evt.detail.modal;
  const body = document.querySelector('body');
  body.appendChild(modal);
});
/* eslint-enable no-console */
